var map = {
	"./img/anatomy-thumb.png": 5302,
	"./img/compete/anatomy/female1.png": 2751,
	"./img/compete/anatomy/female2.png": 292,
	"./img/compete/anatomy/male1.png": 6782,
	"./img/compete/anatomy/male2.png": 4133,
	"./img/compete/anatomy/male3.png": 5036,
	"./img/compete/head/head1.png": 914,
	"./img/compete/head/head2.png": 9097,
	"./img/compete/head/head3.png": 2192,
	"./img/compete/still-life/geometrical1.png": 5841,
	"./img/compete/still-life/geometrical2.png": 6858,
	"./img/compete/still-life/geometrical3.png": 7619,
	"./img/compete/still-life/geometrical4.png": 4012,
	"./img/compete/still-life/geometrical5.png": 1525,
	"./img/croqee-outline-white.png": 2700,
	"./img/default-image.png": 1017,
	"./img/default-image0.png": 861,
	"./img/head-1.png": 2624,
	"./img/logo.png": 2077,
	"./img/rotate-icon.png": 4267,
	"./img/still-life-thumb.png": 7409
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7678;